import { Actor, Engine, vec } from 'excalibur';
import { birdAnimation, birdExplodingAnimation } from './animations';
import { GameplayEvents } from '../types/game-events';
import { EventsManager } from '@game-libs/events-manager';
import { TutorialLevel } from './tutorialLevel';

export class Bird extends Actor {
  birdSpeed = 100;
  alreadyClicked = false;

  constructor() {
    super();

    this.graphics.use(birdAnimation.clone());
    this.z = 3000;
    this.scale = vec(4, 4);

    this.on('pointerdown', () => {
      if (this.alreadyClicked) {
        return;
      }

      this.killBird();
    });
  }

  /**
   * Kills the bird with explosion animation.
   * Can be called from click events or programmatically.
   */
  public killBird(): void {
    if (this.alreadyClicked) {
      return;
    }

    this.alreadyClicked = true;

    const screenCoordinates = this.scene?.engine.worldToScreenCoordinates(this.pos);

    const { emit } = EventsManager();
    emit(GameplayEvents.CLICK_GAME_BIRD, {
      screenCoordinates: screenCoordinates?.scale(0.45),
    });

    birdExplodingAnimation.reset();
    this.graphics.use(birdExplodingAnimation);

    setTimeout(() => {
      this.kill();
    }, 400);
  }

  onAdd(engine: Engine): void {
    const comesFromLeft = Math.random() > 0.5;

    this.vel = vec(comesFromLeft ? this.birdSpeed : -this.birdSpeed, 0);

    this.graphics.flipHorizontal = !comesFromLeft;

    const offsetPosition = (engine.currentScene as TutorialLevel).getOffsetPosition();

    let initialX = Math.random() * -500;

    if (!comesFromLeft) {
      initialX = initialX * -1 + engine.canvasWidth;
    }

    this.pos = vec(initialX, offsetPosition.y - (Math.random() * 280 - 70));
  }

  update(engine: Engine, elapsed: number): void {
    super.update(engine, elapsed);

    if (this.pos.x > engine.canvasWidth * 3 || this.pos.x < -engine.canvasWidth * 2) {
      this.graphics.flipHorizontal = !this.graphics.flipHorizontal;
      this.vel.x *= -1;
    }
  }
}
